import {
  IApplicableBenefit,
  IOrderBasket,
  IOrderBasketOreInfo,
  IOrderBasketCampaignType,
  IBasketOrderItems,
} from "../order/types";
export default class Basket implements IOrderBasket {

  public readonly items: IBasketOrderItems[];
  public readonly applicableBenefits: IApplicableBenefit[];
  public readonly ore: IOrderBasketOreInfo | null;
  public readonly campaignType: IOrderBasketCampaignType | null;
  public readonly participationInTotal: string | number;
  public readonly totalOnCheckout: string | number;
  public readonly activationOfNumber: string | number;
  public readonly specialMsisdn: string | number;
  public readonly totalInFirstBill: string | number;
  public readonly totalMonthlyPayment: string | 0;
  public readonly installationCost: string | 0;
  public readonly deliveryCost: string | 0;

  constructor(
    items: IBasketOrderItems[],
    applicableBenefits: IApplicableBenefit[],
    ore: IOrderBasketOreInfo | null,
    campaignType: IOrderBasketCampaignType | null,
    participationInTotal: string | number,
    totalOnCheckout: string | number,
    activationOfNumber: string | number,
    specialMsisdn: string | number,
    totalInFirstBill: string | number,
    totalMonthlyPayment: string | 0,
    installationCost: string | 0,
    deliveryCost: string | 0
  ) {
    this.items = items;
    this.applicableBenefits = applicableBenefits;
    this.ore = ore;
    this.campaignType = campaignType;
    this.participationInTotal = participationInTotal;
    this.totalOnCheckout = totalOnCheckout;
    this.activationOfNumber = activationOfNumber;
    this.specialMsisdn = specialMsisdn;
    this.totalInFirstBill = totalInFirstBill;
    this.totalMonthlyPayment = totalMonthlyPayment;
    this.installationCost = installationCost;
    this.deliveryCost = deliveryCost;
  }

}
